<template>
    <div>
        <slot
            :filtroOrigen="filtroOrigen"
            :data="data"
            :checkAll="checkAll"
            :loading="loading"
            :tipo="tipo"
            :cambiarAlumnos="cambiarAlumnos"
            :formDestino="formDestino"
            :updateInfo="updateInfo"
            :info="info"
            :config="config"
            :configLoading="configLoading"
            :conexion="conexion"
            :conectar="conectar"
            :relaciones="relaciones"
            :relacionesCiclos="relacionesCiclos"
            :relacionesProgramas="relacionesProgramas"
            :relacionesAtributos="relacionesAtributos">
        </slot>
    </div>
</template>

<script>
import Axios from 'axios';
import selectpicker from "bootstrap-select";

export default {
    data() { return {
        filtroOrigen: {},
        formDestino: {},
        data: [],
        loading: false,
        configLoading: false,
        tipo: 'alumno',
        info: {
            // Orígen
            institucion_id: '',
            ciclo_escolar_id: '',
            programa_id: '',
            atributo_id: '',
            oferta_academica_id: '',
            // Destino
            tipo_destino: '',
            institucion_id_destino: '',
            ciclo_escolar_id_destino: '',
            programa_id_destino: '',
            atributo_id_destino: '',
            oferta_academica_id_destino: '',
        },
        config: {
            institucion_id: null,
            ciclo_escolar_id: null,
            instituciones: [],
        },
        institucion_origen: null,
        conexion: false,
        relaciones: [],
        relacionesCiclos: [],
        relacionesProgramas: [],
        relacionesAtributos: [],
    }},
    mounted() {
        const vm = this;
        const origenForm = $('#origenForm');
        const tipoDestino = $('#tipo_destino');
        const formConfig = $('#formConfig');
        const institucion_id_config = $('#institucion_id_config');
        const institucion_id_destino = $('#institucion_id_destino');

        const institucion_id_origen = $('#institucion_id_origen');
        const ciclo_escolar_id_origen = $('#ciclo_escolar_id_origen');
        const programa_id_origen = $('#programa_id_origen');

        origenForm.submit(function(e) {
            e.preventDefault();
            vm.filtrarOrigen();
        });

        tipoDestino.on('change', function() {
            vm.tipo = tipoDestino.val();
        });

        institucion_id_config.on('change', function() {
            vm.getConfig(institucion_id_config.val());
        });

        institucion_id_destino.on('change', function() {
            vm.conexion = false;
        });

        institucion_id_origen.on('change', function() {
            vm.getCiclos(institucion_id_origen.val());   
            vm.getProgramas(institucion_id_origen.val());   
        });

        programa_id_origen.on('change', function() {
            vm.filtroOrigen.programa_id = programa_id_origen.val();
            vm.getAtributos(programa_id_origen.val());
        });

        formConfig.submit(function(e) {
            e.preventDefault();
            let instituciones = [];
            let ciclo_escolar_id = null;
            let institucion_id = null;

            const data = formConfig.serializeArray();
            data.forEach(item => {
                if(item.value == 'on') {
                    // if(item.name != vm.config.institucion_id) {
                    // }
                    instituciones.push(parseInt(item.name, 10));
                }
                if(item.name == 'ciclo_escolar_id') {
                    ciclo_escolar_id = item.value;
                }
                if(item.name == 'institucion_id') {
                    institucion_id = item.value;
                }
            });
            
            vm.saveconfig(ciclo_escolar_id, institucion_id, instituciones);
        });

        vm.getConfig();
    },
    methods: {
        getAtributos(programa_id) {
            return Axios.get('cambio-institucion/getAtributos', {params: {
                programa_id
            }}).then(res => {
                this.relacionesAtributos = res.data;
            }).catch(e => {

            }).finally(() => {
                if(this.relacionesAtributos.length > 0) {
                    const atributo_id_origen = $('#atributo_id_origen');
                    this.filtroOrigen.atributo_id = this.relacionesAtributos[0].id;
                    atributo_id_origen.selectpicker('val', this.relacionesAtributos[0].id);
                    atributo_id_origen.selectpicker('refresh');
                }
            });
        },
        getProgramas(institucion_id) {
            return Axios.get('cambio-institucion/getProgramas', {params: {
                institucion_id
            }}).then(res => {
                if(res.data.length > 0) {
                    this.relacionesProgramas = res.data;
                    return true;
                }
            }).catch(e => {
                return false;
            }).finally(() => {
                if(this.relacionesProgramas.length > 0) {
                    const programa_id_origen = $('#programa_id_origen');
                    this.filtroOrigen.programa_id = this.relacionesProgramas[0].id;
                    programa_id_origen.selectpicker('val', this.relacionesProgramas[0].id);
                    programa_id_origen.selectpicker('refresh');
                    this.getAtributos(this.relacionesProgramas[0].id);
                }
            });
        },
        getCiclos(institucion_id) {
            return Axios.get('cambio-institucion/getCiclos', {params: {
                institucion_id
            }}).then(res => {
                this.relacionesCiclos = res.data;
            }).catch(e => {

            }).finally(() => {
                if(this.relacionesCiclos.length > 0) {
                    const ciclo_escolar_id_origen = $('#ciclo_escolar_id_origen');
                    this.filtroOrigen.ciclo_escolar_id = this.relacionesCiclos[0].id;
                    ciclo_escolar_id_origen.selectpicker('val', this.relacionesCiclos[0].id);
                    ciclo_escolar_id_origen.selectpicker('refresh');
                }
            });
        },
        getInstituciones(institucion_id) {
            return Axios.get('cambio-institucion/getInstituciones', {params: {
                institucion_id
            }}).then(res => {
                if(res.data && res.data.length > 0) {
                    this.relaciones = res.data;
                    this.conexion = true;
                    toastr["success"]('Conexión establecida con otras Instituciones');
                    return true;
                } else {
                    toastr["warning"]('Otras Instituciones no le han otorgado el permiso para realizar consultas');
                    return false;
                }
            }).finally(() => {
                if(this.relaciones.length > 0) {
                    const institucion_id_origen = $('#institucion_id_origen');
                    this.filtroOrigen.institucion_id = this.relaciones[0].id;
                    institucion_id_origen.selectpicker('val', this.relaciones[0].id);
                    institucion_id_origen.selectpicker('refresh');
                }
            }).catch(e => {
                toastr["error"]('Ocurrió un problema inesperado');
                return false;
            })
        },
        async conectar() {
            const institucion_id_destino = $('#institucion_id_destino');

            const res = await this.getInstituciones(institucion_id_destino.val());
            if(res) {
                await this.getCiclos(this.relaciones[0].id);
                const pro = await this.getProgramas(this.relaciones[0].id);
                if(pro) {
                    await this.getAtributos(this.relacionesProgramas[0].id);
                }
            }

        },
        getConfig(institucion_id) {
            this.configLoading = true;
            Axios.get('cambio-institucion/getConfig'+(institucion_id ? ('/'+institucion_id) : '')).then(res => {
                $('.cambio-institucion-check').prop('checked', false);
                if(res.data.instituciones) {
                    this.actualizarConfig(res.data);
                    this.config.instituciones = res.data.instituciones;
                } else {
                    this.config.instituciones = [];
                    this.configLoading = false;
                }
            }).catch(e => {
                this.configLoading = false;
                toastr["error"]('Ocurrió un problema inesperado');
            });
        },
        actualizarConfig(data) {
            setTimeout(() => {
                $('#ciclo_escolar_id_config').selectpicker('val', data.ciclo_escolar_id);
                this.config.ciclo_escolar_id = data.ciclo_escolar_id;
                this.configLoading = false;
            }, 1000);
        },
        saveconfig(ciclo_escolar_id, institucion_id, instituciones) {
            Axios.post('cambio-institucion/config', {
                ciclo_escolar_id, institucion_id, instituciones
            }).then(res => {
                toastr["success"](res.data.message);
                $('#modalConfig').modal('hide');
            }).catch(e => {
                toastr["error"]('Ocurrió un problema inesperado');
            });
        },
        filtrarOrigen() {
            this.loading = true;
            Axios.get('cambio-institucion/personas', {params: this.filtroOrigen}).then(res => {
                $('#checkAll').prop('checked', false);
                this.data = res.data;
                this.loading = false;
            }).catch(e => {
                this.loading = false;
            });
        },
        checkAll() {
            const check = $('#checkAll');
            const newVal = check.is(":checked");

            this.data.forEach(persona => {
                persona.checked = newVal;
            });
        },
        cambiarAlumnos() {
            const personas_id = []
            this.data.forEach(persona => {
                if(persona.checked) {
                    personas_id.push(persona.id);    
                }
            });
            this.formDestino.data = personas_id;
            Axios.post('cambio-institucion/migrar', this.formDestino).then(res => {
                if(!res.data.error)
                    toastr["success"](res.data.message);
                else toastr["error"](res.data.message);
            }).catch(e => {
                console.log('e', e);
                toastr["error"]('Ocurrió un problema inesperado');
            });
        },
        updateInfo(index) {
            // Destino
            this.info.tipo_destino = $('#tipo_destino').find("option:selected").text();
            this.info.institucion_id_destino = $('#institucion_id_destino').find("option:selected").text();
            this.info.ciclo_escolar_id_destino = $('#ciclo_escolar_id_destino').find("option:selected").text();
            this.info.programa_id_destino = $('#programa_id_destino').find("option:selected").text();
            this.info.atributo_id_destino = $('#atributo_id_destino').find("option:selected").text();
            this.info.oferta_academica_id_destino = $('#oferta_academica_id_destino').find("option:selected").text();

            // Origen
            this.info.institucion_id = $('#institucion_id_origen').find("option:selected").text();
            this.info.ciclo_escolar_id = $('#ciclo_escolar_id_origen').find("option:selected").text();
            this.info.programa_id = $('#programa_id_origen').find("option:selected").text();
            this.info.atributo_id = $('#atributo_id_origen').find("option:selected").text();
            this.info.oferta_academica_id = $('#oferta_academica_id').find("option:selected").text();
        }
    }
}
</script>